import { DocType } from '../../common/Constant';
import { DocEvent } from '../EventEnum';
import { createElement, removeFromParent } from './../../utils/Dom';
import log from 'loglevel';
import AbstractAdapter from './AbstractAdapter';

const ImagePrefix = 'vh-image';
/**
 * 图片适配器
 *
 * @export
 * @class JpegAdapter
 */
export default class JpegAdapter extends AbstractAdapter {
  constructor() {
    super();
    this.prevPageId = -1; // 对比前一次的页码ID， 相同的话就不在进行后续操作了
    this._ext = 'jpg';
    this.prevPageId = -1;
    this.inited = false;
  }

  init(opts = {}) {
    super.init(opts);
    this._info.hash = opts.hash;
    this._docType = DocType.JPG;
    this._info.docType = this._docType;
    this._info.docId = opts['docId'] || '';
    this._info.originWidth = opts['width'] || 0;
    this._info.originHeight = opts['height'] || 0;
    this._info.s = Date.now().toString();
    // this._info.version = process.env.CORE_VERSION;

    this.store.setKV('docType', 2);
  }

  async createEl(elId, uid) {
    super.createEl(elId);
    let el = document.getElementById(elId);

    let img = createElement(
      'img',
      {
        id: ImagePrefix + '-' + uid
      },
      {
        style: 'display:block;position: absolute;border:none;'
      }
    );

    el.appendChild(img);
    this.node = img;

    // 初始化的时候，赋予info 图片宽高
    let url = this.getCurrentPageURL();
    let fetcher = new ImageSizeFetcher();
    let sizeObj = await fetcher.fetch(url);
    const { width, height } = sizeObj;
    this.info.originWidth = width;
    this.info.originHeight = height;
    this.dispatchEvent(DocEvent.READY);
    this._initCompleteCallBK && this._initCompleteCallBK();
  }

  nextPage() {
    super.nextPage();
    if (super.currentPageId === super.totalPage - 1) this.dispatchEvent(DocEvent.PLAYBACKCOMPLETE);
    if (this.prevPageId === this.currentPageId) return;
    this.prevPageId = this.currentPageId;
    this.loadFile();
    this.dispatchEvent();
  }

  prevPage() {
    super.prevPage();
    if (this.prevPageId === this.currentPageId) {
      return;
    }
    this.prevPageId = this.currentPageId;
    this.loadFile();
    this.dispatchEvent();
  }

  gotoPage(pageId) {
    super.gotoPage(pageId);
    if (this.prevPageId === this.currentPageId) {
      return;
    }

    this.prevPageId = this.currentPageId;
    this.loadFile();
    this.dispatchEvent();
  }

  nextStep() {
    super.nextStep();
    this.nextPage();
  }

  prevStep() {
    super.prevStep();
    this.prevPage();
  }

  gotoStep(...args) {
    super.gotoStep(args);
    this.gotoPage(args[0]);
  }

  /**
   * 获取当前页的URL，方便加载 由四部分组成，1:domain 2:hash 3：页数 4:".jpg"
   *
   * @returns 返回当前文档页的路径
   * @memberof JpegAdapter
   */
  getCurrentPageURL() {
    let url = this.opts.urlBase;
    let hash = this.opts.hash;
    const tempPageId = Number(this.currentPageId) || 0;
    return `${url}${hash}/${tempPageId + 1}.jpg`;
  }

  loadFile() {
    if (!this.node) {
      log.warn('image element have not beed inited');
      return;
    }

    let src = this.node.src;
    let newSrc = this.getCurrentPageURL();
    if (src !== newSrc) {
      this.node.src = newSrc;
    }
  }

  dispatchEvent(event = DocEvent.PAGE_CHANGE) {
    let result = {};
    result.event = event;
    result.stamp = Date.now().toString();
    result.cid = this.cid;
    result.doc_type = this.store.getKV('docType') || 2;
    const { userId: selfId, docId } = this.store.getKV('passThrough');
    this.store.setKV('info', Object.assign(this.info, { docId, duration: 1 }));
    // 暂时默认一张图片的加载时长为1s
    result.params = { ...this.info, duration: 1, docId };
    const senderId = this.store.getKV('sender');
    if (senderId === selfId || event === DocEvent.READY || senderId === '' || event === DocEvent.PLAYBACKCOMPLETE) {
      this._ee.dispatch('doc_events', result);
    }
    if (event === DocEvent.PAGE_CHANGE) {
      this._ee.dispatch('report_doc_events', result);
    }
  }

  destroy() {
    super.destroy();

    if (this.node) {
      removeFromParent(this.node);
    }

    this.inited = false;
  }
}

class ImageSizeFetcher {
  constructor() {}
  async fetch(url) {
    return new Promise((resolve, reject) => {
      let result = {};
      let img = new Image();
      img.onload = e => {
        result.width = img.width;
        result.height = img.height;
        resolve(result);
      };

      img.onerror = e => {
        result.width = 540;
        result.height = 860;
        resolve(result);
      };

      img.src = url;
    });
  }
}
